import { defineSlotRecipe } from '@chakra-ui/react';
import { switchAnatomy } from '@chakra-ui/react/anatomy';
// Deep-merges over Chakra's default switch: no shadow anywhere (house rule).
// Chakra's own variants put one back on the thumb (`solid`, `raised`) and an
// inset one on the raised track, and a variant wins over the base, so each is
// cleared where it is set. Everything else stays Chakra's.
export const switchRecipe = defineSlotRecipe({
    slots: switchAnatomy.keys(),
    base: {
        thumb: {
            boxShadow: 'none',
        },
    },
    variants: {
        variant: {
            solid: {
                thumb: { boxShadow: 'none' },
            },
            raised: {
                control: { boxShadow: 'none' },
                thumb: { boxShadow: 'none' },
            },
        },
    },
});
